import { useState } from 'react';
import type { DataTableRowEventParams } from '@/components/custom/erp';
import type { QuocGia } from '@/types/schemas';

export const useRowSelection = () => {
  const [selectedObj, setSelectedObj] = useState<QuocGia | null>(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState<string | null>(null);

  const handleRowClick = (params: DataTableRowEventParams<QuocGia>) => {
    const row = params.row as QuocGia & { id: string | number };
    setSelectedObj(row);
    setSelectedRowIndex(row.id.toString());
  };

  const clearSelection = () => {
    setSelectedObj(null);
    setSelectedRowIndex(null);
  };

  return {
    selectedObj,
    selectedRowIndex,
    handleRowClick,
    clearSelection
  };
};
